import React, { FormEvent } from 'react';
import { Button, styled } from '@mui/material';
import { Search } from '@mui/icons-material';

import FilterBox from 'components/filter-box/FilterBox';
import KeyboardDatePicker from 'components/pickers/KeyboardDatePicker';

export type ExecutiveDashboardPeriod = {
  initialDate: Date | null;
  finalDate: Date | null;
};

type ExecutiveDashboardFilterBoxProps = {
  filter: ExecutiveDashboardPeriod;
  loading: boolean;
  handleChange(index: keyof ExecutiveDashboardPeriod, value: Date | null): void;
  handleSearch(event?: FormEvent<HTMLFormElement>): void;
};

const ExecutiveDashboardFilterBox: React.FC<ExecutiveDashboardFilterBoxProps> = ({
  filter,
  loading,
  handleChange,
  handleSearch,
}) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <KeyboardDatePicker
          label="Data inicial"
          value={filter.initialDate}
          onChange={date => handleChange('initialDate', date)}
          textFieldProps={{ required: true, size: 'small' }}
        />
        <KeyboardDatePicker
          label="Data final"
          value={filter.finalDate}
          onChange={date => handleChange('finalDate', date)}
          textFieldProps={{ required: true, size: 'small' }}
        />
        <Button
          disabled={loading}
          size="small"
          startIcon={<Search fontSize="small" />}
          type="submit"
          variant="contained"
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

const Filter = styled('form')(({ theme }) => ({
  alignItems: 'center',
  display: 'grid',
  gap: theme.spacing(1.5),
  gridTemplateColumns: 'minmax(180px, 240px) minmax(180px, 240px) 130px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export default ExecutiveDashboardFilterBox;
